import { Link } from "react-router-dom";
import logoSrc from "../assets/brand.svg";

export default function SiteLogo() {
  return (
    <div className="logo">
      <Link to="/" className="logo-link" aria-label="JOBUWIN — home">
        <img
          src={logoSrc}
          alt=""
          className="logo-image"
          width={253}
          height={100}
          decoding="async"
        />
      </Link>
    </div>
  );
}
